module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])])]), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/006_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v("The Birth of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Polis")]), _vm._v(" and the Hoplite")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v("The Ascendancy of Sparta")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v("The Lelantine War and the Rise of Athens")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v("The Ionian Revolt and the Greco-Persian Wars")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v("The Peloponnesian War and the Corinthian War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v("The Theban-Spartan War and the Rise of Macedonia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v("Troop Types and Organization of the Greek Armies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v("Panoply and Tactics of the Greek Armies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_BM1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Re-enactors who Contributed to this Book")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0